export const translateText = async (text, sourceLang, targetLang) => {
  try {
    const encodedText = encodeURIComponent(text);
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&tl=${targetLang}&sl=${sourceLang}&dt=t&q=${encodedText}`;

    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Translation API error: ${response.status}`);
    }

    const data = await response.json();
    
    // Google Translate API returns the translated text in the first element
    // of the first array in the response
    if (data && Array.isArray(data) && data.length > 0) {
      const translations = data[0];
      if (Array.isArray(translations) && translations.length > 0) {
        return translations[0][0];
      }
    }

    throw new Error('Invalid translation response format');
  } catch (error) {
    console.error('Translation error:', error);
    throw error;
  }
};
